import axios from 'axios'
import { Message, MessageBox } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: '/api', // api的base_url
  timeout: 60000 // 请求超时时间（结果页等重查询较慢，放宽到 60s）
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应做点什么
    const res = response.data
    
    if (res.code !== 200) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return response.data
    }
  },
  error => {
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        Message({ message: '登录已过期，请重新登录', type: 'error', duration: 5 * 1000 })
        // 延迟跳转，让用户看到提示
        setTimeout(() => {
          window.location.href = '/login'
        }, 500)
        return Promise.reject(error)
      } else if (status === 500) {
        Message({ message: '服务器异常，请稍后重试', type: 'error', duration: 5 * 1000 })
      } else if (status === 403) {
        Message({ message: '没有权限访问', type: 'error', duration: 5 * 1000 })
      } else {
        Message({ message: error.message, type: 'error', duration: 5 * 1000 })
      }
    } else if (error.code === 'ECONNABORTED') {
      Message({ message: '请求超时，请检查网络', type: 'error', duration: 5 * 1000 })
    } else {
      Message({ message: '网络连接失败', type: 'error', duration: 5 * 1000 })
    }
    return Promise.reject(error)
  }
)

export default service